import {Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {AbstractControl, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {FileUploadComponent} from '../../../../../../components/common/file-upload/file-upload.component';
import {FileLikeObject} from 'ng2-file-upload';
import {DocumentCreatePayload} from '../../../impl/service/payload/documentCreate.payload';

@Component({
    selector: 'app-document-create-form',
    templateUrl: './document-create-form.component.html',
})
export class DocumentCreateFormComponent implements OnChanges {

    // Mandatory on component creation!
    @Input('parentFormGroup') parentFormGroup: UntypedFormGroup;
    @Input() removeLabelInput = false;
    @Input() removeCategoryInput = false;


    @ViewChild('fileUpload') fileUploadComponent: FileUploadComponent;

    constructor() {
    }

    get labelControl(): AbstractControl {
        return this.parentFormGroup.controls.label;
    }

    get categoryControl(): AbstractControl {
        return this.parentFormGroup.controls.categoryValue;
    }

    get uploadedFile(): FileLikeObject {
        return this.fileUploadComponent.uploadedFiles?.length > 0 ? this.fileUploadComponent.uploadedFiles[0] : undefined;
    }

    clearFiles() {
        this.fileUploadComponent.reset();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.refreshForm();
    }

    buildPayload(): DocumentCreatePayload {
        const payload: DocumentCreatePayload = Object.assign(new DocumentCreatePayload(), this.parentFormGroup.value);
        payload.attachment = this.fileUploadComponent.uploadedFiles[0];
        return payload;
    }

    private refreshForm() {
        this.parentFormGroup.removeControl('label');
        this.parentFormGroup.removeControl('categoryValue');
        this.parentFormGroup.removeControl('formatValue');

        if (this.parentFormGroup) {
            if (!this.removeLabelInput) {
                this.parentFormGroup.addControl('label', new UntypedFormControl(undefined));
            }
            if (!this.removeCategoryInput) {
                this.parentFormGroup.addControl('categoryValue', new UntypedFormControl('OTHER', Validators.required));

            }
            this.parentFormGroup.addControl('formatValue', new UntypedFormControl('IMAGE', Validators.required));
        }
    }

}
